"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _DialogTitle = _interopRequireDefault(require("@material-ui/core/DialogTitle"));

var _DialogContent = _interopRequireDefault(require("@material-ui/core/DialogContent"));

var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _useTranslate = _interopRequireDefault(require("@sprinx/react-globalize/useTranslate"));

var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));

var _LoginForm = _interopRequireDefault(require("./LoginForm"));

var _RenewPasswordForm = _interopRequireDefault(require("./RenewPasswordForm"));

// import Button from '@material-ui/core/Button';
// import CartFormTextField from '../cart/CartFormTextField';
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {},
    dialog: {},
    title: (0, _extends2.default)({}, theme.typography.body1, {
      fontWeight: 500,
      fontSize: 20,
      textTransform: theme.text.textTransformUppercase
    }),
    titleContainer: (0, _defineProperty2.default)({
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      borderBottom: '1px solid',
      borderBottomColor: theme.palette.another.cart.borders
    }, theme.breakpoints.down('sm'), {
      padding: theme.spacing(1, 2)
    }),
    icon: {
      fill: theme.palette.common.black
    },
    section: (0, _defineProperty2.default)({
      borderBottom: '1px solid',
      borderBottomColor: theme.palette.another.cart.borders,
      padding: theme.spacing(2, 3)
    }, theme.breakpoints.down('sm'), {
      padding: theme.spacing(1, 2)
    })
  };
}, {
  name: 'LoginDialog'
});

var LoginDialog = function LoginDialog(_ref) {
  var pClasses = _ref.classes,
      className = _ref.className,
      errors = _ref.errors,
      isLoginError = _ref.isLoginError,
      isSubmitting = _ref.isSubmitting,
      handleChange = _ref.onChange,
      handleClose = _ref.onClose,
      handleSubmit = _ref.onSubmit,
      open = _ref.open,
      values = _ref.values,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["classes", "className", "errors", "isLoginError", "isSubmitting", "onChange", "onClose", "onSubmit", "open", "values"]);
  var classes = useStyles({
    classes: pClasses
  });
  var t = (0, _useTranslate.default)();
  var theme = (0, _styles.useTheme)();
  var mobile = (0, _useMediaQuery.default)(theme.breakpoints.down('sm'));
  return /*#__PURE__*/_react.default.createElement(_Dialog.default, (0, _extends2.default)({}, rest, {
    open: open,
    onClose: handleClose,
    maxWidth: "sm",
    fullWidth: true,
    fullScreen: !!mobile,
    className: (0, _clsx.default)(classes.root, className, classes.dialog)
  }), /*#__PURE__*/_react.default.createElement(_DialogTitle.default, {
    className: classes.titleContainer,
    disableTypography: true
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: classes.title
  }, t('cartFormLogin/title')), /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    onClick: handleClose
  }, /*#__PURE__*/_react.default.createElement(_Close.default, {
    className: classes.icon
  }))), /*#__PURE__*/_react.default.createElement(_DialogContent.default, {
    className: classes.section
  }, /*#__PURE__*/_react.default.createElement(_LoginForm.default, {
    onClose: handleClose
  }), /*#__PURE__*/_react.default.createElement(_RenewPasswordForm.default, {
    onClose: handleClose
  })));
};

process.env.NODE_ENV !== "production" ? LoginDialog.propTypes = {
  classes: _propTypes.default.shape({
    dialog: _propTypes.default.string,
    icon: _propTypes.default.string,
    root: _propTypes.default.string,
    section: _propTypes.default.string,
    title: _propTypes.default.string,
    titleContainer: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  errors: _propTypes.default.shape({
    forgettenPassword: _propTypes.default.string,
    password: _propTypes.default.string,
    username: _propTypes.default.string
  }),
  isLoginError: _propTypes.default.bool,
  isSubmitting: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  onClose: _propTypes.default.func.isRequired,
  onSubmit: _propTypes.default.func,
  open: _propTypes.default.bool.isRequired,
  values: _propTypes.default.shape({
    forgettenPassword: _propTypes.default.string,
    password: _propTypes.default.string,
    username: _propTypes.default.string
  })
} : void 0;
LoginDialog.defaultProps = {
  classes: undefined,
  className: undefined,
  errors: {},
  isLoginError: false,
  isSubmitting: false,
  onChange: undefined,
  onSubmit: undefined,
  values: undefined
};
var _default = LoginDialog;
exports.default = _default;